import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

// shadcn-shaped ScrollArea primitive (task 799). NOTE: `@radix-ui/react-scroll-area`
// is not in the resolvable dependency set for this worktree (only the Radix
// packages already declared in package.json hoist), so this is a plain
// native-overflow container rather than the Radix-backed shadcn original —
// same call shape (`<ScrollArea className>{children}</ScrollArea>`), so a
// later dependency add can swap the implementation without touching call
// sites. Sufficient for the dock's scrolling message list (M8b).
export const ScrollArea = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function ScrollArea({ className, children, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={cn("relative overflow-y-auto", className)}
      {...props}
    >
      {children}
    </div>
  );
});
